import { useQueryClient } from '@tanstack/react-query';
import { http } from 'services/http';
import { ORDER_GET_ONE } from 'api/query-keys.ts';
import type { TOrderRes, TUpdateOrderReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useUpdateOrder = (orderId: number) => {
  const queryClient = useQueryClient();

  return useMutationBase<TOrderRes, unknown, TUpdateOrderReq>({
    mutationFn: async (variables) => {
      const res = await http.patch<TOrderRes>(`/v1/orders/${orderId}`, variables);

      return res.data;
    },

    onSuccess: (data) => queryClient.setQueryData([ORDER_GET_ONE, data.id], data),
  });
};
